export default __webpack_public_path__ + "static/media/left-pink.9bae8169.svg";